import * as React from "react";
// import Style from "../../_data/models/Style";
import Meta from "../../_data/models/Meta";
import Comment from "../../_data/models/Comment";
import CommentItemContainer from "../containers/CommentItemContainer";
import {formatWithTags} from "../../_helpers/utils";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import {Link} from "react-router-dom";
import {UsersRoutes} from "../../routes";
import {CommentsState} from "../../_definitions/styleteq";
import ReduxInfiniteScroll from "redux-infinite-scroll";

interface Props {
    comments: CommentsState;
    loadMoreComments: (meta: Meta) => void;
}

const CommentsComponent = (props: Props) => {    
    const {comments, loadMoreComments} = props;    
    let count = 0;
    return (                          
        <ReduxInfiniteScroll
            className={'row large-collapse comments p1'}
            loadMore={() => loadMoreComments(comments.meta)}                
            elementIsScrollable={true}
            showLoader={true}
            loadingMore={comments.loading}
            loader={<LoadingIndicatorComponent/>}
            threshold={100}>
            {                   
                comments.items.map((comment) => {                                        
                    return <CommentItemContainer comment={comment} key={count++}/>
                })
            }
        </ReduxInfiniteScroll>                
    );
};

export default CommentsComponent;


// WEBPACK FOOTER //
// ./app/client/comment/components/CommentsComponent.tsx